import CommonError from './common-error';

export class BackendUnavailableError extends CommonError {
  name = 'BackendUnavailableError';

  constructor() {
    super('Backend is unavailable!');
  }
}
